export const findADealOptions = [
  {
    id: 'featuredListings',
    value: 'Featured Listings',
    label: 'Featured Listings',
  },
  { id: 'dealsSteals', value: 'Deals and Steals', label: 'Deals and Steals' },
  { id: 'onSale', value: 'On Sale', label: 'On Sale' },
  //{ id: "freeShipping", value: "Free Shipping", label: "Free Shipping" },
  //{ id: "auction", value: "Auctions", label: "Auctions" },
  //{ id: "offers", value: "Offers Enabled", label: "Offers Enabled" },
];

export const useCaseOptions = [
  'Portrait',
  'Landscape',
  'Macro',
  'Wildlife',
  'Astrophotography',
  'Sports',
  'Wedding',
  'Street',
  'Real Estate',
  'Travel',
  'Video / Cinematography',
  'Vlogging / YouTube',
  'Beginner-Friendly',
  'Night',
  'Studio',
  'Product',
  'Architecture',
  'Documentary',
  'Event',
  'Headshot',
  'Creative Effects',
  'Birding',
  'Adventure',
  'Underwater',
  'Aerial / Drone',
  'Fashion',
  'Food',
].map((label) => {
  const id = label
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-') // Replace spaces/special characters with hyphens
    .replace(/(^-|-$)/g, ''); // Trim starting/trailing hyphens
  return {
    id,
    value: label,
    label,
  };
});

export const lensMountFilters = [
  {
    label: 'Lens Mount',
    field: 'mount.lens',
    type: 'select',
    optionsFromAlgoliaFacet: true,
    options: [
      { brand: 'Arri', label: 'Arri PL' },
      { brand: 'Bronica', label: 'Bronica ETR' },
      { brand: 'Bronica', label: 'Bronica SQ' },
      { brand: 'Canon', label: 'Canon EF' },
      { brand: 'Canon', label: 'Canon EF-M' },
      { brand: 'Canon', label: 'Canon EF-S' },
      { brand: 'Canon', label: 'Canon FD' },
      { brand: 'Canon', label: 'Canon RF' },
      { brand: 'Canon', label: 'Canon Screw Mount' },
      { brand: 'Contax', label: 'Contax' },
      { brand: 'Contax', label: 'Contax 645' },
      { brand: 'Contax', label: 'Contax G' },
      { brand: 'Contax/Yashica', label: 'Contax/Yashica' },
      { brand: 'DJI', label: 'DJI DL' },
      { brand: 'Fuji GX680', label: 'Fuji GX680' },
      { brand: 'Fujifilm', label: 'Fujifilm G' },
      { brand: 'Fujifilm', label: 'Fujifilm X' },
      { brand: 'Generic', label: 'Bayonet' },
      { brand: 'Generic', label: 'C-Mount' },
      { brand: 'Generic', label: 'Lens Board (Technical Camera)' },
      { brand: 'Generic', label: 'M42 Screw Mount' },
      { brand: 'Generic', label: 'PL Mount' },
      { brand: 'Generic', label: 'T-Mount' },
      { brand: 'Hasselblad', label: 'Hasselblad H' },
      { brand: 'Hasselblad', label: 'Hasselblad V' },
      { brand: 'Hasselblad', label: 'Hasselblad XCD' },
      { brand: '', label: 'L Mount Alliance' },
      { brand: 'Leica', label: 'Leica M' },
      { brand: 'Leica', label: 'Leica S' },
      { brand: 'Mamiya', label: 'Mamiya 645' },
      { brand: 'Mamiya', label: 'Mamiya 7' },
      { brand: 'Mamiya', label: 'Mamiya RB' },
      { brand: 'Mamiya', label: 'Mamiya RZ' },
      { brand: 'Mamiya', label: 'Mamiya TLR' },
      { brand: 'Micro Four Thirds', label: 'Micro Four Thirds' },
      { brand: 'Minolta', label: 'Minolta MD' },
      { brand: 'Minolta', label: 'Minolta SR' },
      { brand: 'Nikon', label: 'Nikon AIS' },
      { brand: 'Nikon', label: 'Nikon F' },
      { brand: 'Nikon', label: 'Nikon Z' },
      { brand: 'Olympus', label: 'Olympus OM' },
      { brand: 'Pentax', label: 'Pentax 645' },
      { brand: 'Pentax', label: 'Pentax 67' },
      { brand: 'Pentax', label: 'Pentax K' },
      { brand: 'Pentax', label: 'Pentax Q' },
      { brand: 'Rollei', label: 'Rollei' },
      { brand: 'Samsung', label: 'Samsung NX' },
      { brand: 'Sigma', label: 'Sigma L' },
      { brand: 'Sigma', label: 'Sigma SA' },
      { brand: 'Sony', label: 'Sony A' },
      { brand: 'Sony', label: 'Sony E' },
      { brand: 'Sony', label: 'Sony FE' },
      { brand: 'Voigtländer', label: 'Voigtländer VM' },
    ],
  },
];

export const digitalCameraFilters = [
  /*{
    label: "Camera Type",
    field: "type",
    type: "select",
    options: [
      "DSLR", "Mirrorless", "Medium Format", "Film",
      "Point and Shoot", "Rangefinder", "Other"
    ]
  },*/
  {
    label: 'Crop Factor',
    field: 'sensor.cropFactor',
    type: 'select',
    options: [
      'Full Frame (1.0x)',
      'APS-C (1.5x/1.6x)',
      'Micro Four Thirds (2.0x)',
      'Other',
    ],
  },
  {
    label: 'Sensor Type',
    field: 'sensor.type',
    type: 'select',
    options: [
      'Medium Format',
      'Full Frame (35mm)',
      'APS-H',
      'APS-C',
      'Super 35',
      'Micro Four Thirds (MFT)',
      '1 inch',
      '1.5 inch',
      '1.2 inch',
      '2/3 inch',
      '1/1.7 inch',
      '1/1.8 inch',
      '1/2 inch',
      '1/2.3 inch',
      '1/2.5 inch',
      '1/3 inch',
      '1/4 inch',
      'CX Format (Nikon 1)',
      'Type 4/3 (Four Thirds)',
      'Super 16',
      'Other',
    ],
  },
  {
    label: 'Autofocus System',
    field: 'autofocus.system',
    type: 'select',
    options: [
      'Phase Detection',
      'Contrast Detection',
      'Hybrid (Phase + Contrast)',
      'Dual Pixel AF (Canon)',
      'Quad Pixel AF',
      'Depth from Defocus (Panasonic DFD)',
      'Eye Detection AF',
      'Face Detection AF',
      'Animal Detection AF',
      'AI-Based Subject Tracking',
      'Laser AF',
      'Infrared AF',
      'Rangefinder (Manual)',
      'Manual Focus Only',
      'Other',
    ],
  },
  /*{
    label: "Eye Tracking AF",
    field: "autofocus.eyeTracking",
    type: "boolean"
  },
  {
    label: "Subject Tracking AF",
    field: "autofocus.subjectTracking",
    type: "boolean"
  },
  {
    label: "Burst Mode Support",
    field: "photoSpecs.burstMode",
    type: "boolean"
  },*/
  {
    label: 'Max Photo Resolution',
    field: 'photoSpecs.maxResolution',
    type: 'input', // or custom range logic if format is parseable
  },
  /*{
    label: "Max Burst FPS",
    field: "photoSpecs.maxBurstFrameRate",
    type: "range"
  },
  {
    label: "Max Video Resolution",
    field: "videoSpecs.maxResolution",
    type: "select",
    options: [
              "SD (480p)",
              "HD (720p)",
              "Full HD (1080p)",
              "2K",
              "2.5K",
              "3K",
              "4K",
              "5K",
              "5.7K",
              "6K",
              "6.2K",
              "8K",
              "8.3K",
              "12K",
              "Other"
            ]
  },
  {
    label: "Max Video Frame Rate",
    field: "videoSpecs.maxFrameRate",
    type: "select",
    options: [
      "23.976fps", "24fps", "25fps", "29.97fps", "30fps", "48fps", "50fps",
      "59.94fps", "60fps", "96fps", "100fps", "120fps", "144fps", "180fps",
      "240fps", "480fps", "960fps", "1000fps", "1920fps", "Other"
    ]
  },
  {
    label: "Video Bit Depth",
    field: "videoSpecs.bitDepth",
    type: "select",
    optionsFromAlgoliaFacet: true
  },
  {
    label: "Image Stabilization Type",
    field: "imageStabilization.type",
    type: "select",
    options: [
      "None", "Optical (OIS)", "Sensor-Shift (IBIS)",
      "5-Axis In-Body Stabilization", "Dual IS (Lens + Body)",
      "Digital / Electronic IS", "Lens-Based Stabilization",
      "Gimbal Stabilization", "Other"
    ]
  },
  {
    label: "In-Body Stabilization",
    field: "imageStabilization.inBodyIS",
    type: "boolean"
  },
  {
    label: "Digital Stabilization",
    field: "imageStabilization.digitalIS",
    type: "boolean"
  },
  {
    label: "Storage Media",
    field: "storageMedia",
    type: "multiselect",
    options: [
      "SD", "SDHC", "SDXC", "microSD", "microSDHC", "microSDXC", "CF (CompactFlash)",
      "CFast", "CFexpress Type A", "CFexpress Type B", "CFexpress Type C", "XQD",
      "Memory Stick", "Memory Stick PRO Duo", "SxS (Sony ExpressCard)", "ExpressCard",
      "PCMCIA", "P2 Card (Panasonic)", "RED MINI-MAG", "RED CFexpress",
      "AtomX SSDmini", "SSD (Solid State Drive)", "HDD (Hard Disk Drive)",
      "Optical Disc", "Tape (MiniDV / Digital8 / etc.)",
      "Internal Storage", "Other"
    ]
  },
  {
    label: "Wi-Fi",
    field: "connectivity.wifi",
    type: "boolean"
  },
  {
    label: "Bluetooth",
    field: "connectivity.bluetooth",
    type: "boolean"
  },
  {
    label: "USB-C",
    field: "connectivity.usbC",
    type: "boolean"
  },
  {
    label: "HDMI Output",
    field: "connectivity.hdmiOutput",
    type: "select",
    optionsFromAlgoliaFacet: true
  },
  {
    label: "Headphone Jack",
    field: "connectivity.headphoneJack",
    type: "boolean"
  },
  {
    label: "Microphone Jack",
    field: "connectivity.microphoneJack",
    type: "boolean"
  },
  {
    label: "Weather Sealing",
    field: "bodyDesign.weatherSealing",
    type: "select",
    options: ["None", "Dust Resistant", "Water Resistant", "Weather Sealed"]
  }*/
];

export const lensesFilters = [
  {
    label: 'Lens Type',
    field: 'type',
    type: 'select',
    options: [
      'Prime',
      'Zoom',
      'Pancake',
      'Tilt Shift',
      'Fisheye',
      'Macro',
      'Rangefinder',
    ],
  },
  {
    label: 'Lens Format',
    field: 'lensFormat',
    type: 'select',
    options: [
      'APS-C',
      'APS-C / DX',
      'Four Thirds',
      'Full Frame',
      'Micro Four Thirds',
      'Medium Format',
      'Large Format',
      '1-Inch Sensor',
      '1/2.3-Inch Sensor',
      '1/1.7-Inch Sensor',
      'CX Format',
      'Super 35',
      'Super 16',
    ],
  },
  /*{
    label: "Auto Focus",
    field: "autoFocus",
    type: "select",
    options: ["Auto Focus", "Manual Focus"]
  },*/
  {
    label: 'Focal Range',
    field: 'focalLengthRange',
    type: 'select',
    options: [
      'Standard',
      'Wide Angle',
      'Telephoto',
      'Super Telephoto',
      'Macro',
      'Fisheye',
      'Tilt-Shift',
      'Other',
    ],
  },
  {
    label: 'Focal Length',
    fields: ['minFocalLength', 'maxFocalLength'],
    type: 'range',
  },
];
